import React from 'react'

function VideoCallScreen() {
  return (
    <div>VideoCallScreen</div>
  )
}

export default VideoCallScreen